import React from 'react';
import { Link } from 'react-router-dom';
import { arrowright } from '../../assets/imagesPath';

const WhyUsServices = ({ imageSrc, title, description, linkHref }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8 text-center smallScreens:w-full h-[25.6rem] w-[40.7rem] flex flex-col justify-center">
      <div className="flex justify-center mb-6">
        <img src={imageSrc} alt="img" className="w-24 h-24" />
      </div>
      <h3 className="text-[2rem] font-semibold mb-4 text-gray-800">{title}</h3>
      <p className="text-gray-600 mb-6 text-[1.6rem]">{description}</p>
      <Link
        href={linkHref}
        className="text-[#173363] text-[1.4rem] font-medium hover:underline flex items-center justify-center"
      >
        Read More
        <span>
          <img src={arrowright} alt="arrow" className="h-6 w-6 ml-4" />
        </span>
      </Link>
    </div>
  );
};
export default WhyUsServices